module.exports = __webpack_public_path__ + "static/img/menu_bg.2ffef840.png";